import React from 'react';
import { Star, Lock, Users } from 'lucide-react';
interface ProfileToggleProps {
  activeProfile: 'angel' | 'customer';
  onToggle: (profile: 'angel' | 'customer') => void;
}
export const ProfileToggle: React.FC<ProfileToggleProps> = ({
  activeProfile,
  onToggle
}) => {
  // The component still accepts the same props for backward compatibility
  // but doesn't render the toggle buttons anymore since they're in the header
  // This is an empty component now, as the toggle functionality
  // has been moved to the TopHeader component
  return null;
};